/* eslint-disable no-undef */
import { ListGroup, Dropdown } from "react-bootstrap"
import { Link } from "react-router-dom"
import { generatePath } from "react-router"

import useAuth from "../../../../hooks/useAuth"
import { LogOut, User } from "react-feather"
import SwitchTenant from "./SwitchTenant"
import { RoutePaths } from "../../../../routes/RoutePaths"
import SwitchOrganization from "./SwitchOrganization"
import { useChatContext } from "../../../../assets/js/features/chat/state/context/ChatContext"
import { getUserPermission } from "../../../../assets/js/app/state/appSessionStorage"

const NavRight = () => {
  const { logout } = useAuth()
  const { disconnect } = useChatContext()
  const userPermission = getUserPermission()

  const userIcon = <User size={15} className="m-r-10" />
  const LogoutIcon = <LogOut size={15} className="m-r-10" />

  const handleLogout = async () => {
    try {
      //handleClose();
      await disconnect()
      await logout()
      // sessionStorage.clear()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <>
      <ListGroup as="ul" bsPrefix=" " className="d-flex navbar-nav ml-auto">
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown className="drp-user">
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              id="dropdown-basic"
            >
              {userIcon}
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight className="profile-notification">
              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="pro-body"
              >
                {userPermission?.userId ? (
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to={generatePath(RoutePaths.USER, {
                        userId: userPermission.userId
                      })}
                      className="dropdown-item"
                    >
                      {userIcon} Profile
                    </Link>
                  </ListGroup.Item>
                ) : null}
                <SwitchTenant />
                {/* <SwitchUserRole /> */}
                <SwitchOrganization />
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="#" className="dropdown-item" onClick={handleLogout}>
                    {LogoutIcon} Logout
                  </Link>
                </ListGroup.Item>
              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
    </>
  )
}

export default NavRight
